import { toast } from 'react-toastify';

import { blobToJsonAsync } from './blobToJson';

export const handleDownloadReportError = async (err: any) => {
  const error = await blobToJsonAsync(err.response.data);
  toast.error(error.message);
};
